var menus = {
  BuyCar: '/buy-car',
  SellCar: '/sell-car',
  CustomPage: '/custom-page',
  YuanTongAuction: '',
  News: '/news',
  NewCar: '/NewCar'
  // car_compare: 'vehicleContrast'
  // user: '/user'
}
export default {
  menus: menus
}
